/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * Nestjs FTW
 * The nestjs API description
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import axios from 'axios'
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
export type ReportDistributionControllerGetReportDistributionDetailParams = {
/**
 * id of report distribution
 */
id: unknown;
};

export type ReportDistributionControllerGetListReportDistributionParams = {
/**
 * report distribution create to
 */
dateTo?: unknown;
/**
 * report distribution create from
 */
dateFrom?: unknown;
/**
 * name of report or file name
 */
name?: unknown;
/**
 * number of report to skip
 */
skip?: unknown;
/**
 * number of report to take
 */
take?: unknown;
};

export type CustomerControllerGetListCustomerParams = {
/**
 * ids of customer to not find
 */
excludeIds?: unknown[];
/**
 * name of customer or file name
 */
name?: unknown;
/**
 * number of customer to skip
 */
skip?: unknown;
/**
 * number of customer to take
 */
take?: unknown;
};

export type FileStorageControllerUploadFiles201Item = { [key: string]: any };

export interface ReportDistribution { [key: string]: any }

export interface ReportDistributionConnection { [key: string]: any }

export interface CustomerConnection { [key: string]: any }

export interface FilesUploadDTO {
  files: Blob[];
}

export interface FileUploadDTO {
  file: Blob;
}





/**
 * Upload a file
 */
export const fileStorageControllerUploadFile = (
    fileUploadDTO: FileUploadDTO, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {const formData = new FormData();
formData.append('file', fileUploadDTO.file)

    
    return axios.post(
      `/upload-file`,
      formData,options
    );
  }



export const getFileStorageControllerUploadFileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileStorageControllerUploadFile>>, TError,{data: FileUploadDTO}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof fileStorageControllerUploadFile>>, TError,{data: FileUploadDTO}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fileStorageControllerUploadFile>>, {data: FileUploadDTO}> = (props) => {
          const {data} = props ?? {};

          return  fileStorageControllerUploadFile(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type FileStorageControllerUploadFileMutationResult = NonNullable<Awaited<ReturnType<typeof fileStorageControllerUploadFile>>>
    export type FileStorageControllerUploadFileMutationBody = FileUploadDTO
    export type FileStorageControllerUploadFileMutationError = AxiosError<unknown>

    export const useFileStorageControllerUploadFile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileStorageControllerUploadFile>>, TError,{data: FileUploadDTO}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getFileStorageControllerUploadFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Upload multi files
 */
export const fileStorageControllerUploadFiles = (
    filesUploadDTO: FilesUploadDTO, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FileStorageControllerUploadFiles201Item[]>> => {const formData = new FormData();
filesUploadDTO.files.forEach(value => formData.append('files', value));

    
    return axios.post(
      `/upload-files`,
      formData,options
    );
  }



export const getFileStorageControllerUploadFilesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileStorageControllerUploadFiles>>, TError,{data: FilesUploadDTO}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof fileStorageControllerUploadFiles>>, TError,{data: FilesUploadDTO}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fileStorageControllerUploadFiles>>, {data: FilesUploadDTO}> = (props) => {
          const {data} = props ?? {};

          return  fileStorageControllerUploadFiles(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type FileStorageControllerUploadFilesMutationResult = NonNullable<Awaited<ReturnType<typeof fileStorageControllerUploadFiles>>>
    export type FileStorageControllerUploadFilesMutationBody = FilesUploadDTO
    export type FileStorageControllerUploadFilesMutationError = AxiosError<unknown>

    export const useFileStorageControllerUploadFiles = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileStorageControllerUploadFiles>>, TError,{data: FilesUploadDTO}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getFileStorageControllerUploadFilesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const customerControllerGetListCustomer = (
    params?: CustomerControllerGetListCustomerParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CustomerConnection>> => {
    
    return axios.get(
      `/customer/list-customer`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getCustomerControllerGetListCustomerQueryKey = (params?: CustomerControllerGetListCustomerParams,) => {
    return [`/customer/list-customer`, ...(params ? [params]: [])] as const;
    }

    
export const getCustomerControllerGetListCustomerQueryOptions = <TData = Awaited<ReturnType<typeof customerControllerGetListCustomer>>, TError = AxiosError<unknown>>(params?: CustomerControllerGetListCustomerParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof customerControllerGetListCustomer>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomerControllerGetListCustomerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customerControllerGetListCustomer>>> = ({ signal }) => customerControllerGetListCustomer(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customerControllerGetListCustomer>>, TError, TData> & { queryKey: QueryKey }
}

export type CustomerControllerGetListCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof customerControllerGetListCustomer>>>
export type CustomerControllerGetListCustomerQueryError = AxiosError<unknown>

export const useCustomerControllerGetListCustomer = <TData = Awaited<ReturnType<typeof customerControllerGetListCustomer>>, TError = AxiosError<unknown>>(
 params?: CustomerControllerGetListCustomerParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof customerControllerGetListCustomer>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCustomerControllerGetListCustomerQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const reportDistributionControllerGetReportDistributionFile = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.get(
      `/report-distribution/download`,options
    );
  }


export const getReportDistributionControllerGetReportDistributionFileQueryKey = () => {
    return [`/report-distribution/download`] as const;
    }

    
export const getReportDistributionControllerGetReportDistributionFileQueryOptions = <TData = Awaited<ReturnType<typeof reportDistributionControllerGetReportDistributionFile>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof reportDistributionControllerGetReportDistributionFile>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportDistributionControllerGetReportDistributionFileQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reportDistributionControllerGetReportDistributionFile>>> = ({ signal }) => reportDistributionControllerGetReportDistributionFile({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reportDistributionControllerGetReportDistributionFile>>, TError, TData> & { queryKey: QueryKey }
}

export type ReportDistributionControllerGetReportDistributionFileQueryResult = NonNullable<Awaited<ReturnType<typeof reportDistributionControllerGetReportDistributionFile>>>
export type ReportDistributionControllerGetReportDistributionFileQueryError = AxiosError<unknown>

export const useReportDistributionControllerGetReportDistributionFile = <TData = Awaited<ReturnType<typeof reportDistributionControllerGetReportDistributionFile>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof reportDistributionControllerGetReportDistributionFile>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getReportDistributionControllerGetReportDistributionFileQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const reportDistributionControllerGetListReportDistribution = (
    params?: ReportDistributionControllerGetListReportDistributionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ReportDistributionConnection>> => {
    
    return axios.get(
      `/report-distribution/list-report-distribution`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getReportDistributionControllerGetListReportDistributionQueryKey = (params?: ReportDistributionControllerGetListReportDistributionParams,) => {
    return [`/report-distribution/list-report-distribution`, ...(params ? [params]: [])] as const;
    }

    
export const getReportDistributionControllerGetListReportDistributionQueryOptions = <TData = Awaited<ReturnType<typeof reportDistributionControllerGetListReportDistribution>>, TError = AxiosError<unknown>>(params?: ReportDistributionControllerGetListReportDistributionParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof reportDistributionControllerGetListReportDistribution>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportDistributionControllerGetListReportDistributionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reportDistributionControllerGetListReportDistribution>>> = ({ signal }) => reportDistributionControllerGetListReportDistribution(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reportDistributionControllerGetListReportDistribution>>, TError, TData> & { queryKey: QueryKey }
}

export type ReportDistributionControllerGetListReportDistributionQueryResult = NonNullable<Awaited<ReturnType<typeof reportDistributionControllerGetListReportDistribution>>>
export type ReportDistributionControllerGetListReportDistributionQueryError = AxiosError<unknown>

export const useReportDistributionControllerGetListReportDistribution = <TData = Awaited<ReturnType<typeof reportDistributionControllerGetListReportDistribution>>, TError = AxiosError<unknown>>(
 params?: ReportDistributionControllerGetListReportDistributionParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof reportDistributionControllerGetListReportDistribution>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getReportDistributionControllerGetListReportDistributionQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const reportDistributionControllerGetReportDistributionDetail = (
    params: ReportDistributionControllerGetReportDistributionDetailParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ReportDistribution>> => {
    
    return axios.get(
      `/report-distribution/report-distribution-detail`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getReportDistributionControllerGetReportDistributionDetailQueryKey = (params: ReportDistributionControllerGetReportDistributionDetailParams,) => {
    return [`/report-distribution/report-distribution-detail`, ...(params ? [params]: [])] as const;
    }

    
export const getReportDistributionControllerGetReportDistributionDetailQueryOptions = <TData = Awaited<ReturnType<typeof reportDistributionControllerGetReportDistributionDetail>>, TError = AxiosError<unknown>>(params: ReportDistributionControllerGetReportDistributionDetailParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof reportDistributionControllerGetReportDistributionDetail>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportDistributionControllerGetReportDistributionDetailQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reportDistributionControllerGetReportDistributionDetail>>> = ({ signal }) => reportDistributionControllerGetReportDistributionDetail(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reportDistributionControllerGetReportDistributionDetail>>, TError, TData> & { queryKey: QueryKey }
}

export type ReportDistributionControllerGetReportDistributionDetailQueryResult = NonNullable<Awaited<ReturnType<typeof reportDistributionControllerGetReportDistributionDetail>>>
export type ReportDistributionControllerGetReportDistributionDetailQueryError = AxiosError<unknown>

export const useReportDistributionControllerGetReportDistributionDetail = <TData = Awaited<ReturnType<typeof reportDistributionControllerGetReportDistributionDetail>>, TError = AxiosError<unknown>>(
 params: ReportDistributionControllerGetReportDistributionDetailParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof reportDistributionControllerGetReportDistributionDetail>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getReportDistributionControllerGetReportDistributionDetailQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




